export default __webpack_public_path__ + "static/media/Image-4.ed676656.png";